import React from 'react';
import classnames from 'classnames';

class BreadcrumbNav extends React.Component {
  render () {
    return (
      <ul
        className={classnames('nav nav--breadcrumb', this.props.className)}
        style={{
          padding: '10px 0',
          borderBottom: '1px solid rgba(227, 236, 242, 0.5)',
          marginBottom: 16,
          ...this.props.style,
        }}>
        {this.props.children}
      </ul>
    );
  }
}

BreadcrumbNav.defaultProps = {
  className: '',
};

export default BreadcrumbNav;



// WEBPACK FOOTER //
// ./src/common/views/breadcrumb/BreadcrumbNav.js